import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import proximoImage from '../assets/proximo-preview.png';
import utvalesImage from '../assets/utvales-preview.png';

interface Project {
  name: string;
  description: string;
  url: string;
  image: string;
}

const Projects: React.FC = () => {
  const { t } = useTranslation();

  const projects: Project[] = [
    {
      name: 'Utvales',
      description: t('projects.utvalesDescription'),
      url: 'https://utvales.ealice.it',
      image: utvalesImage,
    },
    {
      name: 'Proximo',
      description: t('projects.proximoDescription'),
      url: 'https://proximo.utvales.ealice.it',
      image: proximoImage,
    },
  ];

  return (
    <section className="py-20 bg-gray-50" id="projects">
      <div className="container mx-auto px-4">
        <motion.h2
          className="text-4xl font-bold text-center mb-12 text-gradient"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          {t('projects.title')}
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={project.name}
              className="bg-white rounded-lg shadow-lg overflow-hidden"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <img src={project.image} alt={project.name} className="w-full h-48 object-cover" />
              <div className="p-6">
                <h3 className="text-2xl font-semibold mb-2">{project.name}</h3>
                <p className="text-gray-600 mb-4">{project.description}</p>
                <a
                  href={project.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 transition-colors"
                >
                  {t('projects.visitProject')}
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;